<template lang="html">
<v-container>
  <v-container>
    <div>
      <h1>{{$t('team.TITLE')}}</h1>
      <div class="subh1"> {{$t('team.TEXT')}} </div>
    </div>
  </v-container>

  <v-layout >
    <v-flex v-for="member in team" style="text-align: center;" >
    <v-card  >
      <v-container>
      <v-avatar size="160">
        <img :src="member.image" />
      </v-avatar>
      <v-container>
        <h2>{{member.name}}</h2>
        <h3>{{member.role}}</h3>
        <a v-if="member.linkedin" :href="member.linkedin">
          <img :src="require('../../public/img/logo-LinkedIn.png')" style="max-height: 1.7em;" />
        </a>
        <v-btn flat v-else disabled style="max-height: 1.3em;">
        </v-btn>
      </v-container>
    </v-container>
    </v-card>
  </v-flex>
  </v-layout>
</v-container>
</template>

<script>
export default {
  data() {
    return {
      team: [{
        name: 'Hervé',
        role: this.$t('role.CEO'),
        image: require('../../public/img/developer3.png'),
        linkedin: 'https://www.linkedin.com/in/herve-escriou/',
        text:this.$t('team.item1.TEXT')
      }, {
        name: 'Arthur',
        role: this.$t('role.CTO'),
        image: require('../../public/img/bipbip.png'),
        linkedin: 'https://www.linkedin.com/in/arthur-escriou-ab6b93aa/',
        text:this.$t('team.item1.TEXT')
      }]
    }
  }
}
</script>

<style lang="css" scoped>
</style>
